<template>
    <div
        v-show="visible"
        id="snippets-variables"
        class="pt-2"
    >
        <templates-picker-snippets-tab
            :allow-create="allowCreate"
            :disable-media="disableMedia"
            @select="$emit('select', $event)"
        />
    </div>
</template>

<script>
import TemplatesPickerSnippetsTab from './TemplatesPickerSnippetsTab.vue';

export default {
    name: "TemplatesPicker",
    components: { TemplatesPickerSnippetsTab },
    props: {
        visible: {
            type: Boolean,
            default: true,
        },
        input: {
            required: true,
        },
        allowCreate: {
            type: Boolean,
            default: true
        },
        disableMedia: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
